"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pathToRegexp = _interopRequireDefault(require("path-to-regexp"));

var _Renderer = _interopRequireDefault(require("./Renderer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var RouteMatcher =
/*#__PURE__*/
function () {
  function RouteMatcher() {
    _classCallCheck(this, RouteMatcher);

    this.init();
  }

  _createClass(RouteMatcher, [{
    key: "init",
    value: function init() {
      this.routes = [];
      this.nameRoutes = {};
      this.renderer = null;
      return this;
    }
  }, {
    key: "addRoute",
    value: function addRoute(path, component, name, isAsync) {
      this.routes.push({
        path: path,
        component: component,
        isAsync: isAsync
      });

      if (!!name) {
        this.nameRoutes[name] = path;
      }
    }
  }, {
    key: "createRenderer",
    value: function createRenderer(pathname) {
      var _this = this;

      var normalizedPathname = this.normalizePathname(pathname);

      var _loop = function _loop(i) {
        var keys = [];
        var route = _this.routes[i];
        var routeMatch = (0, _pathToRegexp.default)(route.path, keys).exec(normalizedPathname);
        if (!routeMatch) return "continue";
        var params = {};

        for (var _i = 1, len = routeMatch.length; _i < len; ++_i) {
          var key = keys[_i - 1];
          params[key.name] = isNaN(routeMatch[_i]) ? decodeURIComponent(routeMatch[_i]) : Number(routeMatch[_i]);
        }

        return {
          v: _this.resolveComponent(route).then(function (component) {
            _this.renderer = new _Renderer.default(normalizedPathname, component, params, _this.renderer);
            return _this.renderer;
          })
        };
      };

      for (var i = 0; this.routes.length > i; i++) {
        var _ret = _loop(i);

        switch (_ret) {
          case "continue":
            continue;

          default:
            if (_typeof(_ret) === "object") return _ret.v;
        }
      }

      this.renderer = null;
      return Promise.resolve(this.renderer);
    }
  }, {
    key: "resolveComponent",
    value: function resolveComponent(route) {
      if (!route.isAsync) {
        return Promise.resolve(route.component);
      }

      return route.component().then(function (component) {
        if (!!component && component.__esModule) {
          return component.default;
        }

        return component;
      });
    }
  }, {
    key: "compileByName",
    value: function compileByName(name) {
      var parameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!this.nameRoutes[name]) {
        throw Error("Route Name \"".concat(name, "\" did not match Path."));
      }

      var toPath = _pathToRegexp.default.compile(this.nameRoutes[name]);

      return toPath(parameters);
    }
  }, {
    key: "normalizePathname",
    value: function normalizePathname(pathname) {
      return pathname.split("?")[0].split("#")[0];
    }
  }]);

  return RouteMatcher;
}();

var _default = RouteMatcher;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./node_modules/async-react-router/lib/RouteMatcher.js
// module id = 131
// module chunks = 0